import React from "react";

/**
 * CAD-style grid + corner bracket overlay. Drop behind any section as a
 * non-interactive industrial backdrop. Pure CSS — zero runtime cost.
 */
export const EngineeringGrid = ({
  className = "",
  gridOpacity = 0.04,
  withBrackets = true,
  withScanline = false,
}) => {
  return (
    <div
      aria-hidden
      className={`absolute inset-0 pointer-events-none overflow-hidden ${className}`}
    >
      {/* Faint CAD grid */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `linear-gradient(to right, rgba(255,255,255,${gridOpacity}) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,${gridOpacity}) 1px, transparent 1px)`,
          backgroundSize: "64px 64px",
          maskImage:
            "radial-gradient(ellipse at center, black 30%, transparent 80%)",
          WebkitMaskImage:
            "radial-gradient(ellipse at center, black 30%, transparent 80%)",
        }}
      />

      {/* Corner brackets — like CAD callout marks */}
      {withBrackets && (
        <>
          <span className="absolute top-6 left-6 w-5 h-5 border-l border-t border-white/20" />
          <span className="absolute top-6 right-6 w-5 h-5 border-r border-t border-white/20" />
          <span className="absolute bottom-6 left-6 w-5 h-5 border-l border-b border-white/20" />
          <span className="absolute bottom-6 right-6 w-5 h-5 border-r border-b border-white/20" />
        </>
      )}

      {/* Optional scanline — subtle laser cut sweep */}
      {withScanline && (
        <span
          className="absolute left-0 right-0 h-[1px] opacity-30"
          style={{
            background:
              "linear-gradient(90deg, transparent 0%, #FF5722 50%, transparent 100%)",
            animation: "scanline 6s linear infinite",
          }}
        />
      )}
    </div>
  );
};
